import { Injectable } from '@angular/core';
import { ButtonItem } from '../../../button/button.model';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { SearchableEntityButtonService } from '../searchable-entity-button.service';
import { SimpleEntityDataService } from './simple-entity-data.service';
import { SimpleEntityActionService } from './simple-entity-action.service';

@Injectable()
export class SimpleEntityButtonService extends SearchableEntityButtonService {

  protected dataService: SimpleEntityDataService;
  protected actionService: SimpleEntityActionService;
  public savePrivilegeList = [];
  public isSaveWithPrivilege: boolean = false;
  
  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  public handleButtonActionForCreate(action: any) {
  }

  // method used to handle button actions in the edit mode
  public handleButtonActionForEdit(action: any) {
    let needYesNoConfirmation = false;
    switch (action) {
      // if there are any actions which need confirmation, add it here.
      case 'Edit': {
        needYesNoConfirmation = true;
        break;
      }
      case 'Save': {
        needYesNoConfirmation = false;
        break;
      }
    }
    if (needYesNoConfirmation) {
      const dialogMsg = 'msg_save_data';
      this.confirmDialogService.yesnocancelDialog(this.resourceService.get(dialogMsg)).subscribe((isConfirmed: any) => {
        if (isConfirmed) {
          this.actionService.savePage().subscribe(response => {
            if (response.statusCode && response.statusCode === 200) {
              const successMsg = 'msg_save_succ';
              this.alertService.clearAll().success(this.resourceService.get(successMsg));
              this.performButtonActions(action);
            } else {
              this.alertService.clearAll().error(this.resourceService.get(response.statusMessage));
            }
          });
        } else if (isConfirmed === false) {
          this.performButtonActions(action);
        }
      });
    } else {
      this.performButtonActions(action);
    }
  }


  public performButtonActions(action: any) {
    //LFWM-3191- Some screens like ship refernece and task dispatch has to call /withPriv api for save action
    // isSaveWithPrivilege is assigned as true in those screens, Save action is replaced with Save with Privilege.
    if (this.isSaveWithPrivilege && action === 'Save') {
      action = 'Save with Privilege';
    }
    switch (action) {
      case 'Edit': {
        this.actionService.editPage();
        break;
      }
      case 'Save': {
        this.actionService.successMsg = this.resourceService.get('msg_save_succ');
        const saveObs = this.actionService.savePage();
        if (saveObs) {
          saveObs.subscribe((response) => {
            if (response.statusCode === 200) {
              // Clear edit flags
              this.dataService.searchService.clearMarkerFlags();
              // this.actionService.clearEditedFlags();if (this.dataService.searchService.getNewPageEventInProgress()) {
              // this save has come while navigating to a new page. Hence continue the navigation
              this.alertService.clearAll().success(this.actionService.successMsg);
              if (this.dataService.displayMode === 'E') {
                this.dataService.setDisplayMode('V');
                this.initializeSearchPageButtons();
              }
              this.dataService.getSearchService().performSearch(); // Added to refresh the data
              this.navService.preventNavigation = false;
            } else {
              this.alertService.clearAll().error(this.resourceService.get(response.error));
            }
          }, (error) => {
            this.alertService.clearAll().error(this.resourceService.get(error));
          });
        }
        break;
      }
      case 'Delete': {
        this.actionService.dialogMsg = this.dataService.createAlertMessage(this.resourceService.get('msg_conf_del'));
        this.actionService.successMsg = this.resourceService.get('msg_del_succ');
        this.actionService.errorMsg = this.resourceService.get('msg_sel_detail');
        this.actionService.delete();
        break;
      }
      case 'Export as Excel': {
        this.exportAsExcel();
        break;
      }
      case 'Export as CSV': {
        this.exportAsCSV();
        break;
      }
      case 'Save with Privilege': {
        this.actionService.successMsg = this.resourceService.get('msg_save_succ');
        const saveObs = this.actionService.savePageWithPrivilege(this.savePrivilegeList);
        if (saveObs) {
          saveObs.subscribe((response) => {
            if (response.statusCode === 200) {
              // Clear edit flags
              this.dataService.searchService.clearMarkerFlags();
              // this.actionService.clearEditedFlags();if (this.dataService.searchService.getNewPageEventInProgress()) {
              // this save has come while navigating to a new page. Hence continue the navigation
              this.alertService.clearAll().success(this.actionService.successMsg);
              if (this.dataService.displayMode === 'E') {
                this.dataService.setDisplayMode('V');
                this.initializeSearchPageButtons();
              }
              this.dataService.getSearchService().performSearch(); // Added to refresh the data
              this.navService.preventNavigation = false;
            } else {
              this.alertService.clearAll().error(this.resourceService.get(response.error));
            }
          }, (error) => {
            this.alertService.clearAll().error(this.resourceService.get(error));
          });
        }
        break;
      }
    }
  }

  public printReport() {
    // To be implemented
  }

  public initializeSearchPageButtons() {
    if (!this.dataService.searchService ||
      !this.dataService.searchService.getPagedData() ||
      !this.dataService.searchService.getPagedData().pageRows ||
      this.dataService.searchService.getPagedData().pageRows.length <= 0) {
      this.buttonFactoryService.rebuildButtonArray(this.userButtonMap['search-table'],
        []);
    }
  }

  protected exportAsExcel() {
    this.actionService.exportData(this.dataService.searchService, 'excel');
  }

  protected exportAsCSV() {
    this.actionService.exportData(this.dataService.searchService, 'csv');
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/services/searchable-entity/simple-entity/simple-entity-button.service.ts